/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgForward5 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11.707 1.293 15.414 5l-3.707 3.707-1.414-1.414 1.279-1.28a7 7 0 1 0 7.424 7.228L19 13h2a9 9 0 1 1-9.406-8.991l-1.301-1.302zm2.212 9.254v1.143h-2.547l-.162 1.404c.306-.108.618-.162.936-.162.666 0 1.191.178 1.575.535s.576.848.576 1.472c0 .438-.099.82-.297 1.148s-.478.58-.842.76-.787.27-1.273.27c-.372 0-.727-.036-1.067-.108s-.628-.171-.868-.297v-1.197c.264.132.56.235.886.31s.644.113.95.113c.384 0 .687-.09.909-.27s.333-.426.333-.738c0-.3-.091-.534-.275-.702s-.442-.252-.778-.252c-.39 0-.789.09-1.197.27l-.792-.621.378-3.078z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgForward5 as Forward5 };
